import { browserName } from "react-device-detect";
import { store } from "../redux/Store";
import { segmentProps } from "./SegmentProperties";

export const getDeviceProp = () => ({
  device: `${segmentProps.web} - ${browserName.toLowerCase()}`,
});

export const getCommonProps = () => {
  const state = store.getState();
  return {
    shopId: state?.store?.details?.id,
    shopName: state?.store?.details?.name,
    address: state?.store?.details?.address,
  };
};

export const getEventNameByKey = (key) => {
  const state = store.getState();
  if (state?.segmentEvents?.events?.[key]) {
    return state.segmentEvents.events[key];
  }
  return null;
};

export const getCommonUserProps = (user) => {
  return {
    email: user.email,
    phone: user.cellPhone,
    userName: user.name,
  };
};
